export enum Roles {
    ROLE_COLLECTION_CREATE_EDIT_DELETE = 98,
    ROLE_COLLECTION_ADMIN = 99,
}
